angular.module('ihestiaCommonDirectives.changeLanguage', [

]);
